import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var TextboxIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11444 3.83333C3.96071 3.83333 3.83333 3.96071 3.83333 4.11444V7.54889C3.83333 7.70263 3.96071 7.83 4.11444 7.83H7.54889C7.70263 7.83 7.83 7.70263 7.83 7.54889V4.11444C7.83 3.96071 7.70263 3.83333 7.54889 3.83333H4.11444ZM2 4.11444C2 2.94818 2.94818 2 4.11444 2H7.54889C8.71515 2 9.66333 2.94818 9.66333 4.11444V7.54889C9.66333 8.71515 8.71515 9.66333 7.54889 9.66333H4.11444C2.94818 9.66333 2 8.71515 2 7.54889V4.11444Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11444 40.17C3.9607 40.17 3.83333 40.2974 3.83333 40.4511V43.8856C3.83333 44.0393 3.9607 44.1667 4.11444 44.1667H7.54889C7.70263 44.1667 7.83 44.0393 7.83 43.8856V40.4511C7.83 40.2974 7.70263 40.17 7.54889 40.17H4.11444ZM2 40.4511C2 39.2848 2.94818 38.3367 4.11444 38.3367H7.54889C8.71515 38.3367 9.66333 39.2848 9.66333 40.4511V43.8856C9.66333 45.0518 8.71515 46 7.54889 46H4.11444C2.94818 46 2 45.0518 2 43.8856V40.4511Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4511 40.17C40.2974 40.17 40.17 40.2974 40.17 40.4511V43.8856C40.17 44.0393 40.2974 44.1667 40.4511 44.1667H43.8856C44.0393 44.1667 44.1667 44.0393 44.1667 43.8856V40.4511C44.1667 40.2974 44.0393 40.17 43.8856 40.17H40.4511ZM38.3367 40.4511C38.3367 39.2848 39.2848 38.3367 40.4511 38.3367H43.8856C45.0518 38.3367 46 39.2848 46 40.4511V43.8856C46 45.0518 45.0518 46 43.8856 46H40.4511C39.2848 46 38.3367 45.0518 38.3367 43.8856V40.4511Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4511 3.83333C40.2974 3.83333 40.17 3.9607 40.17 4.11444V7.54889C40.17 7.70263 40.2974 7.83 40.4511 7.83H43.8856C44.0393 7.83 44.1667 7.70263 44.1667 7.54889V4.11444C44.1667 3.9607 44.0393 3.83333 43.8856 3.83333H40.4511ZM38.3367 4.11444C38.3367 2.94818 39.2848 2 40.4511 2H43.8856C45.0518 2 46 2.94818 46 4.11444V7.54889C46 8.71515 45.0518 9.66333 43.8856 9.66333H40.4511C39.2848 9.66333 38.3367 8.71515 38.3367 7.54889V4.11444Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82556 12.0833C6.33182 12.0833 6.74222 12.4937 6.74222 13V35C6.74222 35.5063 6.33182 35.9167 5.82556 35.9167C5.31929 35.9167 4.90889 35.5063 4.90889 35V13C4.90889 12.4937 5.31929 12.0833 5.82556 12.0833Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1744 12.0833C42.6807 12.0833 43.0911 12.4937 43.0911 13V35C43.0911 35.5063 42.6807 35.9167 42.1744 35.9167C41.6682 35.9167 41.2578 35.5063 41.2578 35V13C41.2578 12.4937 41.6682 12.0833 42.1744 12.0833Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0833 5.82556C12.0833 5.31929 12.4937 4.90889 13 4.90889H35C35.5063 4.90889 35.9167 5.31929 35.9167 5.82556C35.9167 6.33182 35.5063 6.74222 35 6.74222H13C12.4937 6.74222 12.0833 6.33182 12.0833 5.82556Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0833 42.1744C12.0833 41.6682 12.4937 41.2578 13 41.2578H35C35.5063 41.2578 35.9167 41.6682 35.9167 42.1744C35.9167 42.6807 35.5063 43.0911 35 43.0911H13C12.4937 43.0911 12.0833 42.6807 12.0833 42.1744Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3667 15.1511C13.3667 14.6448 13.7771 14.2344 14.2833 14.2344H33.7167C34.2229 14.2344 34.6333 14.6448 34.6333 15.1511C34.6333 15.6574 34.2229 16.0678 33.7167 16.0678H14.2833C13.7771 16.0678 13.3667 15.6574 13.3667 15.1511Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8656 14.2344C24.3718 14.2344 24.7822 14.6448 24.7822 15.1511V34.5844C24.7822 35.0907 24.3718 35.5011 23.8656 35.5011C23.3593 35.5011 22.9489 35.0907 22.9489 34.5844V15.1511C22.9489 14.6448 23.3593 14.2344 23.8656 14.2344Z"
  }));
});
TextboxIcon.displayName = 'TextboxIcon';
TextboxIcon.defaultProps = {
  'aria-label': 'Textbox'
};
export default TextboxIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/TextboxIcon/index.js
// module id = 1959
// module chunks = 12